import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הדאגנות",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להפסיק את הדאגה.",
      "אני רק מזהה: היא כאן."
    ],
      [
      "היום אני לא מנסה להפסיק את הדאגה.",
      "אני רק מזהה: היא כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "על מה הדאגה הכי פעילה היום?",
      "מה עולה יחד איתה בגוף?",
      "מה המשפט הפנימי שחוזר?"
    ],
      [
      "על מה הדאגה הכי פעילה היום?",
      "מה עולה יחד איתה בגוף?",
      "מה המשפט הפנימי שחוזר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "דאגה היא חוויה, לא עובדה."
    ],
      [
      "דאגה היא חוויה, לא עובדה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני רואה את הדאגה\".",
      "נשימה אחת + \"אני רואה את הדאגה\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הטריגר הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שמדליק את הדאגה.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני שם/ה לב למה שמדליק את הדאגה.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קרה רגע לפני שהדאגה עלתה?",
      "באיזה זמן ביום זה קורה?",
      "מה אני מנסה למנוע?"
    ],
      [
      "מה קרה רגע לפני שהדאגה עלתה?",
      "באיזה זמן ביום זה קורה?",
      "מה אני מנסה למנוע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני מזהה טריגר, יש לי מרחב קטן."
    ],
      [
      "כשאני מזהה טריגר, יש לי מרחב קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשזה מתחיל.",
      "נשימה אחת כשזה מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "אותות הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הדאגה יושבת בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ],
      [
      "איפה הדאגה יושבת בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מנסה לשמור עלי."
    ],
      [
      "הגוף מנסה לשמור עלי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפורי דאגה",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הסיפורים שהדאגה מספרת.",
      "אני לא נלחם/ת בהם."
    ],
      [
      "היום אני מזהה את הסיפורים שהדאגה מספרת.",
      "אני לא נלחם/ת בהם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה תסריט קופץ ראשון?",
      "מה בו הכי מפחיד?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ],
      [
      "איזה תסריט קופץ ראשון?",
      "מה בו הכי מפחיד?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא עובדה."
    ],
      [
      "סיפור הוא לא עובדה."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "מה הדאגה מכסה",
    opening: localizedGenderNode(
      [
      "היום אני רואה כמה הדאגה מתפזרת לכל כיוון.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני רואה כמה הדאגה מתפזרת לכל כיוון.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת רגע בשקט.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת רגע בשקט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "על אילו נושאים אני דואג/ת עכשיו?",
      "מה הנושא שחוזר הכי הרבה?",
      "מה אני רוצה להרגיש במקום זה?"
    ],
      [
      "על אילו נושאים אני דואג/ת עכשיו?",
      "מה הנושא שחוזר הכי הרבה?",
      "מה אני רוצה להרגיש במקום זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשהתמונה ברורה, יש פחות רעש."
    ],
      [
      "כשהתמונה ברורה, יש פחות רעש."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת של נושא.",
      "לכתוב מילה אחת של נושא."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הלופ שחוזר",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הלופ של הדאגה.",
      "בלי ביקורת."
    ],
      [
      "היום אני מזהה את הלופ של הדאגה.",
      "בלי ביקורת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הסיבוב שחוזר אצלי?",
      "איך הוא מתחיל בדרך כלל?",
      "איך אני מרגיש/ה אחרי שהוא עובר?"
    ],
      [
      "מה הסיבוב שחוזר אצלי?",
      "איך הוא מתחיל בדרך כלל?",
      "איך אני מרגיש/ה אחרי שהוא עובר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לופ הוא תבנית, לא אני."
    ],
      [
      "לופ הוא תבנית, לא אני."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"זה לופ\".",
      "לומר לעצמי \"זה לופ\"."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הצורך שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת את הצורך שמתחת לדאגה.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מחפש/ת את הצורך שמתחת לדאגה.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני באמת בוחר/ת/ה?",
      "מה אני מנסה להגן עליו?",
      "איך זה מרגיש כשיש קצת ביטחון?"
    ],
      [
      "מה אני באמת בוחר/ת/ה?",
      "מה אני מנסה להגן עליו?",
      "איך זה מרגיש כשיש קצת ביטחון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מאחורי דאגה יש בקשה."
    ],
      [
      "מאחורי דאגה יש בקשה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב בקשה אחת לעצמי.",
      "לכתוב בקשה אחת לעצמי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "להיות עם אי ודאות",
    opening: localizedGenderNode(
      [
      "היום אני פוגש/ת את האי ודאות בלי לברוח.",
      "אני נשאר/ת רגע."
    ],
      [
      "היום אני פוגש/ת את האי ודאות בלי לברוח.",
      "אני נשאר/ת רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הכי לא ודאי לי עכשיו?",
      "מה קשה לי לשאת בזה?",
      "איזה משפט עדין יכול לעזור לי להחזיק רגע?"
    ],
      [
      "מה הכי לא ודאי לי עכשיו?",
      "מה קשה לי לשאת בזה?",
      "איזה משפט עדין יכול לעזור לי להחזיק רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה לשהות רגע בתוך אי ודאות."
    ],
      [
      "אני יכול/ה לשהות רגע בתוך אי ודאות."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המשפט שלי.",
      "נשימה אחת עם המשפט שלי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "שיחה פנימית רכה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ],
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מדבר/ת אל עצמי כשאני דואג/ת?",
      "איך הייתי רוצה שידברו אלי?",
      "מה המשפט הרך שלי?"
    ],
      [
      "איך אני מדבר/ת אל עצמי כשאני דואג/ת?",
      "איך הייתי רוצה שידברו אלי?",
      "מה המשפט הרך שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול רך מוריד לחץ."
    ],
      [
      "קול רך מוריד לחץ."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט הרך פעם אחת.",
      "לומר את המשפט הרך פעם אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "להניח רגע",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה מרגיש להניח את הדאגה לרגע.",
      "רק רגע."
    ],
      [
      "היום אני בודק/ת איך זה מרגיש להניח את הדאגה לרגע.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ],
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה בי כשאני מניח/ה את הדאגה?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ],
      [
      "מה קורה בי כשאני מניח/ה את הדאגה?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להניח לרגע זה גם לבחור."
    ],
      [
      "להניח לרגע זה גם לבחור."
    ]
    ),
    action: localizedGenderNode(
      "לשים לב לרגע אחד בלי לדאוג.",
      "לשים לב לרגע אחד בלי לדאוג."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "חזרה להווה",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ],
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ],
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ההווה נותן לי קרקע."
    ],
      [
      "ההווה נותן לי קרקע."
    ]
    ),
    action: localizedGenderNode(
      "להרגיש את כפות הרגליים לרגע.",
      "להרגיש את כפות הרגליים לרגע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לפני חיפוש ודאות",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני חיפוש ודאות.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני חיפוש ודאות.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף לבדוק.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף לבדוק.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מחפש/ת לדעת עכשיו?",
      "מה יקרה אם לא אדע מיד?",
      "מה יכול לעזור לי להמתין רגע?"
    ],
      [
      "מה אני מחפש/ת לדעת עכשיו?",
      "מה יקרה אם לא אדע מיד?",
      "מה יכול לעזור לי להמתין רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להמתין רגע זה כוח שקט."
    ],
      [
      "להמתין רגע זה כוח שקט."
    ]
    ),
    action: localizedGenderNode(
      "לעצור רגע לפני בדיקה.",
      "לעצור רגע לפני בדיקה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן שיכול לעזור.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת צעד קטן שיכול לעזור.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שמרגיע אותי?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ],
      [
      "מה צעד קטן שמרגיע אותי?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק הוא מספיק."
    ],
      [
      "קטן מספיק הוא מספיק."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן אחד.",
      "לבחור צעד קטן אחד."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ],
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הדאגנות הזו?",
      "מה הסימן הראשון שהיא עולה?",
      "מה המשפט הקצר שלי?"
    ],
      [
      "מה למדתי על הדאגנות הזו?",
      "מה הסימן הראשון שהיא עולה?",
      "מה המשפט הקצר שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת רגע לפני תגובה."
    ],
      [
      "אני בוחר/ת רגע לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + המשפט שלי.",
      "נשימה אחת + המשפט שלי."
    ),
  },
].map(buildNormalizedDay);

export const anxietyGeneralBlueprintHe = buildNormalizedPilotBlueprint({
  id: "anxiety_general_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "anxiety_general",
  category: "anxiety",
  journeyName: {
    he: "דאגנות יתר בכל נושא",
    en: "Excessive worry about everything",
    es: "Preocupacion excesiva por todo",
  },
  days,
});

export default anxietyGeneralBlueprintHe;
